import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { storage } from './firebase'

/** Uploads a user's avatar to its fixed Storage path and returns the download URL. */
export async function uploadAvatar(uid: string, blob: Blob): Promise<string> {
  const avatarRef = ref(storage, `users/${uid}/avatar`)
  await uploadBytes(avatarRef, blob, {
    contentType: blob.type || 'image/jpeg',
    cacheControl: 'public, max-age=31536000, immutable',
  })
  return getDownloadURL(avatarRef)
}
